import { useTranslation } from 'react-i18next';
import AccountTerminationModalBase from '@/components/ModalRenderer/components/components/AccountTerminationModalBase';
import type { ModalProps } from '@/components/ModalRenderer/components/types';

type Props = ModalProps<{ refundedAmount?: number }>;

const LoanIdProtectTerminationInGracePeriod = ({ payload: { refundedAmount } }: Props) => {
  const { t } = useTranslation('Modal');

  return (
    <AccountTerminationModalBase
      title={t('LoanIdProtectTerminationInGracePeriod.title')}
      buttonText={t('LoanIdProtectTerminationInGracePeriod.button')}
    >
      <p>{t('LoanIdProtectTerminationInGracePeriod.info')}</p>

      {refundedAmount ? (
        <p>{t('LoanIdProtectTerminationInGracePeriod.infoWithRefundedAmount', { refundedAmount })}</p>
      ) : null}

      <p>{t('LoanIdProtectTerminationInGracePeriod.feedbackInfo')}</p>
    </AccountTerminationModalBase>
  );
};

export default LoanIdProtectTerminationInGracePeriod;
